export default "__VITE_ASSET__DGo3bhv5__"